import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, navigate } from 'raviger';
import { Button, Card, Col, Modal, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import L from "leaflet";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faInfoCircle, faPlusSquare, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { faPencil, faBuilding } from '@fortawesome/pro-solid-svg-icons';
import { faTimesSquare } from '@fortawesome/pro-regular-svg-icons';
import Header from '../components/Header';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import ActionsDropdown from '../components/ActionsDropdown';
import LoadingLink from "../components/LoadingLink";

function ShelterManagement({ organization, id }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [removeBuilding, setRemoveBuilding] = useState({});


  const removeBuildingSubmit = () => {
    axios.delete('/shelter/api/building/' + removeBuilding.id + '/')
    .then(response => {
      setData(prev => ({...prev, buildings: prev.buildings.filter(building => building.id !== removeBuilding.id)
      }));
      setShowModal(false);
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  const openModal = (building) => {
    setRemoveBuilding(building);
    setShowModal(true);
  }

  const [data, setData] = useState({
    name: '',
    address: '',
    full_address: '',
    city: '',
    state: '',
    zip_code: '',
    description: '',
    image: '',
    phone: '',
    display_phone: '',
    buildings: [],
    unroomed_animals: [],
    intake_summaries: [],
  });
  //const [selectedShelter, setSelectedShelter] = useState(null);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchShelterData = async () => {
      // Fetch Shelter Details data.
      await axios.get('/shelter/api/shelter/' + id + '/?organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData(response.data);
          setIsLoading(false);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchShelterData();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
    <span className="mt-4 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/shelters')} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      {data.name} - Manage Buildings
      <OverlayTrigger
        key={"new-building"}
        placement="bottom"
        overlay={
          <Tooltip id={`tooltip-new-building`}>
            Add new building
          </Tooltip>
        }
      >
        <Link style={{cursor:'pointer', marginLeft:'10px'}} href={`/${organization}/manage/shelters/${id}/buildings/new`}>
          <FontAwesomeIcon icon={faPlusSquare} size="sm" inverse />
        </Link>
      </OverlayTrigger>
    </Header>
    <Row className="flex-nowrap" style={{paddingBottom:"10px"}}>
      <Col style={{minWidth:"150px", maxWidth:"150px", marginLeft:"0px"}}>
          Building Name
      </Col>
      <Col style={{minWidth:"250px", maxWidth:"250px", marginLeft:"0px"}}>
          Building Description
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px"}}>
          Room Count
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px"}}>
      </Col>
    </Row>
    {data.buildings.map(building => (
      <Card key={building.id} className="rounded mb-1" style={{maxWidth:"0px"}}>
        <div className="row no-gutters flex-nowrap" style={{marginLeft:"0px"}}>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {building.name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"250px", maxWidth:"250px", backgroundColor:"#615e5e"}}>
            {building.description}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {building.rooms.length}
          </Col>
          <Col className="border" style={{paddingLeft:"3px", paddingTop:"2px", marginTop: "-1px", fontSize:"13px", minWidth:"100px", maxWidth:"100px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
            <ActionsDropdown variant="secondary" title="Actions" style={{height:"26px", paddingTop:"0px"}}>
              <LoadingLink
                href={"/" + organization + "/manage/shelters/buildings/edit/" + building.id}
                isLoading={isLoading}
                className="d-block"
                label="Update Building"
              >
                <FontAwesomeIcon icon={faPencil} className="fas" inverse />
              </LoadingLink>
              <LoadingLink
                href={"/" + organization + "/manage/shelters/buildings/" + building.id}
                isLoading={isLoading}
                className="d-block"
                label="Manage Rooms"
              >
                <FontAwesomeIcon icon={faBuilding} className="fas" inverse />
              </LoadingLink>
              <LoadingLink
                onClick={() => openModal(building)}
                isLoading={isLoading}
                className="d-block"
                label="Remove Building"
              >
                <FontAwesomeIcon icon={faTimesSquare} className="fas" inverse />
              </LoadingLink>
            </ActionsDropdown>
          </Col>
        </div>
      </Card>
    ))}
    </span>
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Building Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <b>Building Name: </b>{removeBuilding.name}
        <br/><br/>
        <p style={{marginTop:"-10px", marginBottom:"-5px"}}>Are you sure you want to remove this building?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => removeBuildingSubmit()}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default ShelterManagement
